export default function HelpContentBlock({ img, text }) {
  return (
    <div className="helpContentBlock">
      <div className="helpContentBlock__img">
        <div className="helpContentBlock__divider">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <img src={require(`@shared/assets/emoji/${img}.svg`)} alt="" />
      </div>
      <p dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
}
